import { Action } from '@ngrx/store';
import { ButtonPressedEvent } from '../../shared/events/button-pressed.event';

export enum ButtonActionTypes {
  BUTTON_SIGNALR_STATE_CHANGED = '[Button API] Button State Changed',
  BUTTON_PLAYER_ACTION_COMPLETED = '[Player] Action completed',
}

export class ButtonSignalRStateChanged implements Action {
  readonly type = ButtonActionTypes.BUTTON_SIGNALR_STATE_CHANGED;

  constructor(public payload: ButtonPressedEvent) {}
}

export class ButtonPlayerActionCompleted implements Action {
  readonly type = ButtonActionTypes.BUTTON_PLAYER_ACTION_COMPLETED;

  constructor(public payload: { HotelCode: string; UnitCode: string }) {}
}

export type ButtonPressedActionsUnion = ButtonSignalRStateChanged | ButtonPlayerActionCompleted;
